<template>
  <dialog-form
      content-class="dialog-form ssl-hosting-popup"
      v-bind="$attrs"
      v-on="$listeners"
      :show="showPopup"
      @close="handleClose"
      :activator="false"
      maxWidth="100%"
      closable
  >
    <h2 class="popup-title">{{ isSsl ? $t(`popupSsl.title`) : 'Виберіть тариф хостингу'}}</h2>

    <v-expansion-panels v-model="panel" variant="accordion" class="accordion-panel" @change="scrollToCurrentPanel()">
      <v-expansion-panel
        v-for="(group, index) in computedSsl"
        :key="index"
      >
        <span :ref="'firstElement-' + index"></span>
        <v-expansion-panel-header data-attr="panel-activator" expand-icon="sr-icon-arrow-down">
          <h3>{{ $t(`popupSsl.categories.${group.category}.title`) }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ul v-if="isSsl" class="benefits-list">
            <li
              v-for="(benefit, benefitIndex) in getCategoryBenefits(group.category)"
              :key="benefitIndex"
            >
              <v-icon class="sr-icon-check"/> {{ benefit }}
            </li>
          </ul>

          <div v-if="isSsl" class="ssl-table">

            <div class="thead">
              <div class="tr">
                <span
                  v-for="(headKey) in SSL_POPUP.TABLE"
                  :key="headKey"
                  :class="['th', headKey]"
                >
                  <span class="hint" v-if="headKey === 'issuance'" data-attr="${headKey}-head-tooltip">
                    <v-tooltip right max-width="330">
                      <template v-slot:activator="{ on }">
                        <span class="link" v-on="on" @click.stop="$event.preventDefault()">{{ $t(`popupSsl.tableHead.${headKey}`) }}</span>
                      </template>
                      <div v-html="$t(`popupSsl.details.${headKey}.tooltip`)"></div>
                    </v-tooltip>
                  </span>

                  <span v-else>
                    {{ $t(`popupSsl.tableHead.${headKey}`) }}
                  </span>
                </span>
              </div>
            </div>

            <div class="tbody">
              <div
                v-for="(ssl, sslIndex) in group.items"
                :key="sslIndex"
                :class="[
                  'tr',
                  isBest(group.category, ssl.pid) ? 'best' : '',
                  isPromo(group.category, ssl.pid) ? 'promo' : ''
                  ]"
              >

                <span
                  v-for="(headKey) in SSL_POPUP.TABLE"
                  :key="headKey"
                  :class="['td', headKey]"
                >

                  <template v-if="headKey === 'name'">
                    <img v-if="ssl.brand" class="img" :src="require(`@/assets/images/${ssl.brand}.svg`)" :alt="ssl.brand">
                    <div class="heading">
                      <v-icon class="sr-icon-lock-check" />{{ ssl[headKey] }}
                    </div>
                    <div class="details">
                      <span
                          @click="toggleExpand(sslIndex, index)"
                          :class="{'is-active': activeDetails[`${sslIndex}-${index}`]}"
                      >
                        <span class="link">{{ activeDetails[`${sslIndex}-${index}`] ? $t('actions.hideDetails') : $t('actions.details') }}</span><v-icon class="sr-icon-expand"/>
                      </span>
                    </div>
                  </template>

                  <template v-else-if="headKey === 'greatFor'">
                    <span v-html="variablesList(ssl.fields[headKey], 'popupSsl.details.greatFor', false)"/>
                  </template>

                  <template v-else-if="headKey === 'price'">
                    <div>

                      <span class="old"
                            v-if="ssl.pid === '481'"
                            v-html="priceTransform(numberTransform(getPrice(ssl, 'annually', 1, true)), currencyInfo.suffix, '', currencyInfo.prefix) + ' / ' + $tc('numberedYear', 1)">
                      </span>

                      <span :class="isPromo(group.category, ssl.pid) ? 'old' : 'new'"
                            v-html="priceTransform(numberTransform(getPrice(ssl, 'annually', 1)), currencyInfo.suffix, '', currencyInfo.prefix) + ' / ' + $tc('numberedYear', 1)">
                      </span>

                      <template v-if="isPromo(group.category, ssl.pid)">
                        <span class="badge promo">{{ $t(`popupSsl.promo`) }}</span>
                        <span class="new"
                              v-html="priceTransform(numberTransform(getPrice(ssl, 'biennially', 2)), currencyInfo.suffix, '', currencyInfo.prefix) + ' / ' + $tc('numberedYear', 1)">
                        </span>
                        <span class="hint">{{ $t(`popupSsl.promoHint`) }}</span>
                      </template>

                      <v-btn :ripple="false" color="primary" @click="handleOrder(ssl)">{{ $t(`popupSsl.order`) }}</v-btn>
                    </div>
                  </template>

                  <template v-else-if="headKey === 'issuance' || headKey === 'validation'">
                    {{ $t(`popupSsl.details.${headKey}.${ssl.fields[headKey]}.table`) }}
                  </template>
                  <template v-else>{{ $t(`popupSsl.details.${headKey}.${ssl.fields[headKey]}`) }}</template>
                </span>

                <v-expand-transition>
                  <div class="td expand" v-if="showDetails.includes(`${sslIndex}-${index}`)">
                    <p v-html="ssl.description[currencyInfo.lang.toLowerCase()]"></p>
                    <h4>{{ $t(`popupSsl.details.title`) }}</h4>
                    <ul>

                      <li
                        v-for="(ssl, key) in getFilteredDetails(ssl.fields)"
                        :key="key"
                      >
                          <span v-if="isTooltipSsl(key)" class="hint detail-name" :data-attr="`${key}-tooltip`">
                          <v-tooltip right max-width="330">
                            <template v-slot:activator="{ on }">
                              <span class="link" v-on="on" @click.stop="$event.preventDefault()">
                                {{ $t(`popupSsl.details.${key}.title`) }}
                              </span>
                            </template>
                            <div v-html="$t(`popupSsl.details.${key}.tooltip`)"></div>
                          </v-tooltip>
                          </span>
                          <span v-else class="detail-name">{{ $t(`popupSsl.details.${key}.title`) }}</span>
                          <span v-html="getItemContent(key, ssl) || '&#8212;'"></span>
                      </li>

                    </ul>
                  </div>
                </v-expand-transition>
              </div>
            </div>
          </div>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="footer-support">
      <span v-html="$t(`popupSsl.needAdviceChat`)" />
      <span @click="startChatHandler" class="link"><b>{{ $t('popupSsl.inChat') + '!' }}</b></span>
      <v-icon class="sr-icon-comment"/>
    </div>
  </dialog-form>
</template>

<script>
import {priceTransform} from '@/modules/priceTransform';
import DialogForm from '@/shared/components/DialogForm/DialogForm.vue';
import { SSL_POPUP } from '@/constants';
import {mapGetters} from "vuex";
import {SETTINGS_GETTERS} from "@/store/modules/settings";
import {numberTransform} from "@/modules/numberTransform";

export default {
    name: "SslHostingPopup",
    components: {
      DialogForm
    },
    props: {
      showPopup: { type: Boolean, default: false },
      currencyInfo: { type: [Object, Array], default: () => ({}) },
      isSsl: { type: Boolean, default: true },
      sslItems: { type: [Object, Array], default: () => ([]) },
      state: String,
      startChat: {type: Function, required: true}
    },
    data: () => ({
      panel: 0,
      showDetails: [],
      activeDetails: {},
      paymentPeriod: {}
    }),
    computed: {
      ...mapGetters('settings', {
        currency: SETTINGS_GETTERS.CURRENCY,
        currencySuffix: SETTINGS_GETTERS.CURRENCY_SUFFIX,
        currencyPrefix: SETTINGS_GETTERS.CURRENCY_PREFIX,
      }),
      SSL_POPUP() {
        return SSL_POPUP
      },
      computedSsl() {
        return SSL_POPUP.GROUP_ORDER.map(category => ({
          category,
          items: this.sslItems
            .filter(item => {
              if (Array.isArray(item.category)) {
                return item.category.includes(category);
              }
              return item.category === category;
            })
        }));
      },
      isTooltipSsl() {
        return headKey => SSL_POPUP.DETAILS_TOOLTIP.includes(headKey);
      }
    },
    methods: {
      numberTransform,
      priceTransform,
      startChatHandler() {
        this.startChat();
        if (window.zE) {
          window.zE('webWidget', 'open');
        }
      },
      scrollToCurrentPanel() {
        this.$nextTick(() => {
          setTimeout(() => {
            const activePanelIndex = this.panel;
            const activePanelRef = `firstElement-${activePanelIndex}`;
            const activeElement = this.$refs[activePanelRef] && this.$refs[activePanelRef][0];
            if (activeElement) {
              activeElement.scrollIntoView({ behavior: 'smooth' });
            }
          }, 300);
        });
      },
      handleClose() {
        this.$emit('update:showPopup', false);
      },
      handleOrder(ssl) {
        this.$emit('update:state', 'popup-active');
        this.$emit('update:upsellData', { key: 'ssl', data: ssl });
        this.$emit('update:showPopup', false);
      },
      toggleExpand(itemIndex, index) {
        const key = `${itemIndex}-${index}`;

        this.$set(this.activeDetails, key, !this.activeDetails[key]);

        if (this.showDetails.includes(key)) {
          this.showDetails = this.showDetails.filter(item => item !== key);
        } else {
          this.showDetails = [...this.showDetails, key];
        }
      },
      variablesList(list, lang, useFormatting = true) {
        if (!Array.isArray(list) || list.length === 0) return '';
        const translatedList = list.map(key => this.$t(`${lang}.${key}`));
        if (useFormatting) {
          if (translatedList.length === 1) {
            return translatedList[0];
          }
          const firstPart = translatedList.slice(0, -1).join(', ');
          const lastPart = translatedList[translatedList.length - 1];
          return `${firstPart} ${this.$t('and')} ${lastPart}`;
        }
        return translatedList.join('<br>');
      },
      getFilteredDetails(fields) {
        return Object.keys(fields)
          .filter(key => SSL_POPUP.DETAILS.includes(key) && (key !== 'sealInSearch' || fields[key]))
          .reduce((obj, key) => {
            obj[key] = fields[key];
            return obj;
          }, {});
      },
      getCategoryBenefits(category) {
        return this.$t(`popupSsl.categories.${category}.benefits`, []);
      },
      getItemContent(key, item) {
        switch (key) {
          case 'issuance':
          case 'validation':
            return this.$t(`popupSsl.details.${key}.${item}.dropdown`);
          case 'subdomainsProtection':
          case 'companyNameInSSLDetails':
          case 'mobileSupport':
          case 'sealInSearch':
            return item ? '+' : '&#8212;';
          default:
            return this.$t(`popupSsl.details.${key}.${item}`) || '&#8212;';
        }
      },
      isBest(category, pid) {
        if(pid === '481') {
          return true
        }
        const groupObj = SSL_POPUP.ACTIVE.find(group => category in group);
        if (groupObj) {
          const ids = groupObj[category];
          return ids.includes(String(pid));
        }
        return false;
      },
      isPromo(category, pid) {
        const groupObj = SSL_POPUP.PROMO.find(group => category in group);
        if (groupObj) {
          const ids = groupObj[category];
          return ids.includes(String(pid));
        }
        return false;
      },
      getPrice(item, period, factor = 1, freeSsl = false) {
        const itemProduct = freeSsl ? item.productFreeSsl : item.product;

        const filteredCycles = itemProduct.billingcycles.filter(
          billing => billing.currency_code === this.currency
        );
        const cycle = filteredCycles.find(billing => billing.period === period);
        if (cycle) {
          return cycle.price / factor;
        }
        return 0;
      },
    }
  }
</script>

<style lang="scss">
  .v-dialog.ssl-hosting-popup {
    margin: 20px;
    max-height: calc(100% - 40px);

    @media (max-width: $tablet) {
      margin: 0;
      max-height: 100%;
    }

    .dialog-content {

      @media (max-width: $tablet) {
        padding: 40px 10px;
      }
    }

    .popup-title {
      font-size: 21px;
      margin-bottom: 35px;
    }
  }

  .accordion-panel.v-expansion-panels {
    padding-bottom: 40px;

    .v-expansion-panel {
      color: $black;
      margin-top: 0;
      position: relative;

      &:first-child:before, &:after{
        opacity: 1 !important;
        content: "" !important;
        position: absolute !important;
        bottom: 0;
        width: 100%;
        height: 1px;
        border-top: 1px solid rgba(127, 127, 127, 0.4) !important;
        top: auto;
        display: block !important;
      }

      &:first-child:before {
        top: 0;
      }
    }

    .v-expansion-panel-header {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 24px;

      h3 {
        font-size: 19px;
        margin-bottom: 0;
        order: 2;
        width: calc(100% - 36px);
      }

      .v-expansion-panel-header__icon {
        order: 1;
        margin-right: 16px;

        .v-icon {
          font-size: 20px;
          color: $primary;
        }
      }
    }

    .v-expansion-panel-content {

      .benefits-list {
        margin-bottom: 32px;
      }

      .hosting-info {
        padding: 0 62px;
        max-width: 1200px;

        @media (max-width: $tablet) {
          padding: 0;
        }

        &:last-of-type {
          margin-bottom: 60px;

          @media (max-width: $tablet) {
            margin-bottom: 40px;
          }
        }
      }

      .hosting-details {
        padding: 25px 20px 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        .link {
          color: $black !important;
          margin-right: 9px;

          &:after {
            background-color: rgba($black, .5);
          }
        }

        i {
          font-size: 11px;
          color: rgba($black, .5);
        }

        .is-open {

          i {
            transform: rotate(180deg);
          }
        }
      }
    }

    .v-expansion-panel-content__wrap {
      padding-bottom: 0;
    }
  }

  .benefits-list {
    padding-left: 60px !important;
    list-style: none;

    @media (max-width: $phablet) {
      padding-left: 10px !important;
    }

    li {
      display: flex;
      align-items: baseline;
      width: 100%;
    }

    i.v-icon {
      font-size: 10px;
      color: $black;
      padding-right: 8px;
      height: 100%;
    }
  }

  .ssl-table {
    font-size: 16px;
    width: 100%;
    border-collapse: collapse;

    .hint {
      font-size: 16px;
      color: $black;
      display: inline-block;

      .link {
        color: $black !important;
        text-decoration: none;

        &:after {
          background-color: transparent;
          border-top: 1px dashed $gray;
        }
      }
    }

    .thead {
      @media (max-width: $widescreen) {
        display: none;
      }
    }

    .tbody {

      .tr {
        position: relative;
        align-items: stretch;
        margin-bottom: 10px;
        border: 1px solid transparent;

        &:nth-child(odd) {
          background-color: $gray-table;
          border-color: $gray-table;
        }

        &:last-child:not(:only-child) {
          overflow: hidden;
        }
      }
    }

    .tr {
      display: flex;
      flex-wrap: wrap;
      border-radius: 7px;

      @media (max-width: $phablet) {
        padding: 32px 15px;
      }

      &.best {
        border-color: #98E7C2 !important;
        background-color: #F2FFF9 !important;
      }

      &.promo {
        .td {
          @media (max-width: $desktop) {
            padding: 25px 5px;
          }
        }
      }
    }

    .th {
      padding: 0 2px 12px;
      font-size: 16px !important;
      font-weight: 700;
    }

    .td {
      padding: 32px 8px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      flex-direction: column;

      @media (max-width: $desktop) {
        padding: 15px 5px;
      }

      @media (max-width: $phablet) {
        width: 100% !important;
        padding: 0;
        text-align: center;
      }

      &:not(:first-child) {
        align-items: center;
      }
    }

    .th, .td {

      &:first-child {
        padding-left: 20px;

        @media (max-width: $desktop) {
          padding-left: 10px;
        }

        @media (max-width: $phablet) {
          padding-left: 0;
        }
      }

      &:not(:first-child) {
        text-align: center;
        position: relative;

        &:after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          border-left: 1px $gray-soft dashed;
          height: calc(100% + 10px);
          width: 1px;

          @media (max-width: $widescreen) {
            display: none;
          }
        }
      }

      &.name {
        width: 20%;

        @media (max-width: $widescreen) and (min-width: $phablet) {
          width: 28%;
        }

        @media (max-width: $phablet) {
          padding-bottom: 20px;
        }
      }

      &.greatFor {
        width: 17%;

        @media (max-width: $widescreen) and (min-width: $phablet) {
          width: 35%;
        }

        @media (max-width: $phablet) {
          padding-bottom: 20px;
        }
      }

      &.assurance {
        width: 14%;
        word-break: break-word;

        @media (max-width: $widescreen) {
          display: none;
        }
      }

      &.validation {
        width: 12%;
        word-break: break-word;

        @media (max-width: $widescreen) {
          display: none;
        }
      }

      &.issuance {
        width: 13%;

        @media (max-width: $widescreen) {
          display: none;
        }
      }

      &.price {
        width: 24%;
        position: relative;

        @media (max-width: $widescreen) and (min-width: $phablet) {
          width: 37%;
        }

        @media (max-width: $phablet) {
          position: static;
        }

        div > span {
          display: flex;
          align-items: center;
          width: 100%;

          &:not(:last-child) {
            padding-bottom: 3px;
          }
        }

        .old {
          color: #999;

          .price-transform {
            position: relative;

            &:after {
              content: "";
              position: absolute;
              left: 0;
              width: calc(100% - 3px);
              top: 50%;
              height: 1px;
              background: #999;
              pointer-events: none;
            }
          }
        }

        .old, .new {

          .price-transform {
            font-weight: 700;
            font-size: 19px;
            padding-right: 3px;
          }
        }

        .hint {
          font-size: 14px;
        }

        .v-btn {
          margin-top: 8px;
        }

        .badge {
          top: -7px;
        }
      }

      &.expand {
        width: 100%;
        text-align: left;
        display: block;
        font-size: 19px;
        padding-bottom: 24px;
        padding-left: 20px;
        padding-right: 20px;

        @media (max-width: $desktop) {
          padding-left: 10px;
          padding-right: 10px;
        }

        @media (max-width: $phablet) {
          padding-top: 40px;
          padding-bottom: 0;
        }

        &:after {
          display: none;
        }

        h4 {
          font-size: 19px;
          margin-bottom: 15px;
        }

        ul {
          list-style: none;
          padding-left: 0;
          font-size: 16px;
          column-count: 3;

          @media (max-width: $phablet) {
            column-count: auto;
          }

          li {
            padding-bottom: 3px;
            break-inside: avoid;

            span.detail-name {

              &:after {
                content: ':';
                display: inline;
              }
            }

            span:nth-child(2) {
              font-weight: 700;
              padding-left: 3px;
            }
          }
        }
      }
    }

    .img {
      width: 100%;
      max-width: 120px;
      display: block;
      margin-bottom: 12px;

      @media (max-width: $phablet) {
        margin-left: auto;
        margin-right: auto;
      }
    }

    .heading {
      margin-bottom: 11px;
      font-size: 19px;
      font-weight: 700;
      position: relative;

      i {
        color: $black;
        font-size: 16px;
        margin-right: 4px;
        display: inline-block;
        vertical-align: baseline;
      }

      .text {
        display: inline;
        line-height: 1.4;
      }
    }

    .details {
      display: block;

      span {
        display: inline-flex;
        align-items: baseline;

        &:hover {
          cursor: pointer;
        }

        &.is-active {

          i {
            transform: rotate(180deg);
          }
        }
      }

      i {
        font-size: 10px;
        padding-left: 4px;
        padding-right: 4px;
        color: rgba($black, .5);
        transition: $transition;
      }
    }
  }

  .footer-support {
    padding: 28px;
    text-align: center;
    background-color: $gray-table;
    font-size: 19px;
    margin: 0 -34px -32px;

    @media (max-width: $tablet) {
      margin: 0 -10px -40px;
      padding: 14px;

      b {
        display: block;
      }
    }

    i.v-icon {
      margin-left: 4px;
      color: $primary;
      font-size: 16px;
    }

    .link {
      color: $black !important;
      font-size: 19px;

      &:after {
        background-color: $black !important;
      }
    }
  }

  .badge {
    text-align: center;
    color: $white;
    height: 28px;
    max-width: 284px;
    width: 80% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    position: absolute;
    z-index: 2;
    top: -28px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-color: $secondary;
    mask: url('~@/assets/images/ribbon.svg') no-repeat center / contain;

    &.promo {
      background-color: #FF435C;
    }
  }
</style>
